<template>
  <div>
    <content-loader v-if="$apollo.loading" title="City details" />
    <div v-else>
      <page-header class="city-banner" :title="city.name">
        <template #secondary>
          <div class="title mb-3">
            <h2 class="cs-textstyle-paragraph">
              <i class="icons8-user-account"></i
              >{{ totalMembers | formatNumber }}&nbsp;{{
                'Member' | pluralize(totalMembers)
              }}
            </h2>
          </div>
        </template>
      </page-header>

      <div class="container city-detail">
        <div class="row no-gutters city-detail-about">
          <div class="col-lg-3">
            <div
              class="city-image"
              v-imagekit.background="{
                image: city.picture,
                transform: 'w-300,h-240,fo-auto'
              }"
            ></div>
          </div>
          <div class="col-lg-9">
            <div class="basic-info">
              <div class="row">
                <div class="col-md-7">
                  <h5 class="cs-textstyle-item-heading">About</h5>
                  <p class="description">
                    A community of CTOs in {{ city.name }} who help
                    each other succeed.
                  </p>
                </div>
                <div class="col-md-5">
                  <member-info-card
                    v-if="city.manager"
                    card-title="Community Manager"
                    :member="city.manager"
                  ></member-info-card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row city-detail-members">
          <div class="col-lg-12">
            <div class="block" v-if="city.members && city.members.length">
              <member-list-card
                card-title="Latest Members"
                :members="city.members"
                limit="3"
              ></member-list-card>
            </div>
          </div>
        </div>
        <local-event-jobs :events="events" :jobs="jobs"></local-event-jobs>
      </div>
    </div>
  </div>
</template>
<script>
import { GetCity } from '@/newgql/GetCity.gql';
import ListEventsByCity from '@/newgql/ListEventsByCity.gql';
import ListJobsByCity from '@/newgql/ListJobsByCity.gql';
import ContentLoader from '@/components/global/ContentLoader';
import PageHeader from '@/components/global/PageHeader';
import MemberInfoCard from '@/components/global/MemberInfoCard';
import MemberListCard from '@/components/global/MemberListCard';
import LocalEventJobs from '@/components/cities/LocalEventJobs.vue';

export default {
  components: {
    ContentLoader,
    PageHeader,
    MemberInfoCard,
    MemberListCard,
    LocalEventJobs
  },

  apollo: {
    city: {
      query: GetCity,
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    },
    events: {
      query: ListEventsByCity,
      variables() {
        return {
          city_id: this.$route.params.id,
          today: this.$moment()
        };
      }
    },
    jobs: {
      query: ListJobsByCity,
      variables() {
        return {
          city_id: this.$route.params.id
        };
      }
    }
  },

  computed: {
    totalMembers() {
      return this.city && this.city.member_count;
    }
  }
};
</script>

<style lang="scss" scoped>
.city-banner {
  /deep/ .banner-content h1 {
    font-size: 49px;
  }

  .title h2 {
    color: var(--cs-gray-00);

    i {
      margin-right: 7px;
      color: var(--cs-gray-00);
    }
  }
}

.city-detail {
  margin-bottom: 50px;
  margin-top: -65px;
}
.city-detail-about {
  background: var(--cs-gray-00);
  @include media-breakpoint-up(lg) {
    height: 199px;
  }
  border-radius: 10px;
}
.city-detail-members {
  margin-top: 60px;
}

.city-image {
  display: none;
  @include media-breakpoint-up(lg) {
    display: block;
    height: 199px;
    background-color: $grey;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
}

.basic-info {
  background-color: #ffffff;
  padding: 15px;
  margin-bottom: 40px;
  border-radius: 10px;
  @include media-breakpoint-up(lg) {
    margin-bottom: 80px;
    padding: 25px;
  }

  p.description {
    font-size: 15px;
    color: #505b64;
  }
}

.block {
  position: relative;

  &:last-of-type {
    &:after {
      content: none;
    }
  }

  &:after {
    content: '';
    width: 100%;
    height: 1px;
    background-color: #e8e8e8;
    position: absolute;
    bottom: -13px;
    left: 0;
  }
}
</style>
